import { cloneDeep } from "lodash";

import dateUtil from "./dateUtil";
import adminUserUtils from "./adminUserUtils";
import { strCode } from "../consts";
import { t } from "../services";
import { rolesConfigUtils } from "../containers/UserManagement/NewUserForm/utils/rolesConfigUtils";

const getIsActive = (user) => {
  const currentDate = new Date().getTime();

  return !!(
    (adminUserUtils.isUserAdmin(user) &&
      user.activeFrom <= currentDate &&
      user.activeTo >= currentDate) ||
    user.groups?.some((group) => group.activeFrom <= currentDate && group.activeTo >= currentDate)
  );
};

const getUserMarkets = (groups) => {
  const allMarkets = [];

  (groups ?? []).forEach((group) => {
    if (group?.markets) {
      allMarkets.push(...group.markets);
    }
  });

  return [...new Set(allMarkets)];
};

const formatUsers = (users) => {
  return users?.length > 0
    ? users.map((user) => {
        return {
          ...user,
          id: user.email,
          active: getIsActive(user)
        };
      })
    : [];
};

const formatUsersDates = (user) => {
  const updatedUser = cloneDeep(user);

  updatedUser.activeFrom = dateUtil.getDateFromTimestamp(user.activeFrom);
  updatedUser.activeTo = dateUtil.getDateFromTimestamp(user.activeTo);

  if (updatedUser?.groups?.length > 0) {
    updatedUser.groups = updatedUser.groups.map((group) => {
      return {
        ...group,
        activeFrom: dateUtil.getDateFromTimestamp(group?.activeFrom),
        activeTo: dateUtil.getDateFromTimestamp(group?.activeTo)
      };
    });
  }

  return updatedUser;
};

const formatUserLoginInfoTimestamp = (timestamp) => {
  if (!timestamp) {
    return null;
  }

  const isToday = dateUtil.isToday(new Date(timestamp));
  const isYesterday = dateUtil.isYesterday(new Date(timestamp));

  if (isToday) {
    return t(strCode.TODAY);
  }

  if (isYesterday) {
    return t(strCode.YESTERDAY);
  }

  return dateUtil.formatDateFromTimestamp(timestamp, false);
};

const prepareUserData = (user, isAdminUser) => {
  const updatedUser = cloneDeep(user);

  updatedUser.email = updatedUser.email.toLowerCase();

  if (!isAdminUser) {
    updatedUser.channels = ["RETAIL"];
    updatedUser.groups = rolesConfigUtils.prepareUserGroups(user.groups);
  }

  return updatedUser;
};

const userUtil = {
  getIsActive,
  getUserMarkets,
  formatUsers,
  formatUsersDates,
  formatUserLoginInfoTimestamp,
  prepareUserData
};

export default userUtil;
